// Tiny industry-feature-gate helper. Mirror of core/industry.py — keep the
// two in sync if you add another vertical-specific feature.

export const isLegalIndustry = (industry) => {
  if (!industry || typeof industry !== 'string') return false;
  return industry.trim().toLowerCase().startsWith('legal_');
};
